'use client';

import { Link } from 'src/navigation';
import styles from './library-and-store-links.module.scss';
import TrackedDownloadButton from 'components/controls/links/download-button/tracked-download-button';
import DropdownNavigation from 'components/controls/dropdown-navigation';

const LibraryAndStoreLinks = ({ publication, title }: IProps) => {
	const {
		storeLink,
		worldcatId,
		watsonRecordId,
		googleBookLink,
		googleBookIsSample,
		inPrint,
		pdf,
	} = publication;

	if (!storeLink && !worldcatId && !watsonRecordId && !pdf) {
		return null;
	}

	const printStatus = inPrint
		? `This title is in print.`
		: `This title is out of print.`;

	const libraryLinks = [];
	watsonRecordId &&
		libraryLinks.push({
			href: `https://library.metmuseum.org/record=${watsonRecordId}`,
			text: "The Met's Watson Library",
		});
	worldcatId &&
		libraryLinks.push({
			href: `https://www.worldcat.org/title/${worldcatId}`,
			text: 'WorldCat',
		});

	return (
		<div className={styles.container}>
			<div className={styles.printStatusMessage}>{printStatus}</div>
			<div className={styles.buttonsContainer}>
				{(worldcatId || watsonRecordId) && (
					<DropdownNavigation links={libraryLinks} text={'Find in a library'} />
				)}
				{pdf?.url && (
					<TrackedDownloadButton
						analytics={{
							contentType: 'MetPubs',
							contentBlock: 'CTA',
							contentId: publication._id,
							contentName: title,
						}}
						file={pdf}
						showIcon={false}
						variant="secondary"
					/>
				)}
				{storeLink && (
					<Link href={storeLink} className="button secondary">
						Buy the book
					</Link>
				)}
				{!googleBookIsSample && googleBookLink && (
					<Link href={googleBookLink} className="button secondary">
						Read online
					</Link>
				)}
			</div>
		</div>
	);
};

export interface IProps {
	publication: {
		_id: string;
		googleBookIsSample: boolean;
		googleBookLink?: string;
		inPrint: boolean;
		pdf?: {
			size: number;
			url: string;
		};
		storeLink?: string;
		watsonRecordId?: string;
		worldcatId?: string;
	};
	title: string;
}

export default LibraryAndStoreLinks;
